/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Status_PaidInputs */

const fr_payment_status_paid = /** @type {(inputs: Payment_Status_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payé`)
};

/**

* @param {Payment_Status_PaidInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const payment_status_paid = /** @type {((inputs?: Payment_Status_PaidInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Status_PaidInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_payment_status_paid(inputs)
});